/* Revery — Delivery details widget.
 * Extracted from sections/delivery-details.liquid for size + cacheability.
 * Reads dynamic values via data-* attributes on [data-revery-delivery]:
 *   - data-rv-pickup-map: the Google Maps URL for the pickup location
 */
(function () {
  const root = document.querySelector('[data-revery-delivery]');
  if (!root) return;

  /* Per-emirate same-day cutoff hour (24h local). "Sharjah" without
     "city" falls back to next-day (7 AM cutoff = effectively next-day). */
  const CUTOFFS = {
    'Abu Dhabi': 23,
    'Dubai': 15,
    'Sharjah city': 15,
    'Sharjah': 7,
    'Al Ain': 7,
    'Ajman': 7,
    'Umm Al Quwain': 7,
    'Ras Al Khaimah': 7,
    'Fujairah': 7
  };

  /* Hardcoded slots — Abu Dhabi / Dubai / Sharjah city get the three named
     windows. Other emirates (incl. wider Sharjah) show the estimated default. */
  const NAMED_SLOTS = ['08:00am - 10:00am', '10:00am - 02:00pm', '02:00pm - 06:00pm', '06:00pm - 09:00pm', '09:00pm - 12:00am'];
  const NAMED_EMIRATES = ['Abu Dhabi'];
  const DEFAULT_SLOT_LABEL = 'Evening delivery';
  const DEFAULT_SLOT_VALUE_DEFAULT = 'Evening 2:00 PM – 10:00 PM';
  /* Per-emirate evening window. Dubai starts later. */
  const EVENING_WINDOWS = {
    'Dubai': { start: '4:00 PM', end: '10:00 PM', value: 'Evening 4:00 PM – 10:00 PM' }
  };
  function getEveningWindow(emirate) {
    return EVENING_WINDOWS[emirate] || { start: '2:00 PM', end: '10:00 PM', value: DEFAULT_SLOT_VALUE_DEFAULT };
  }
  /* Emirates we don't deliver to. Selecting one shows an unavailable
     notice and blocks checkout via validate(). */
  const BLOCKED_EMIRATES = ['Al Dhafra region'];
  /* Each slot's END hour (24h). Used to disable slots that are too
     close to closing to reasonably prep + dispatch. */
  const SLOT_END_HOURS = { '08:00am - 10:00am': 10, '10:00am - 02:00pm': 14, '02:00pm - 06:00pm': 18, '06:00pm - 09:00pm': 21, '09:00pm - 12:00am': 24 };
  /* Minimum lead time in hours from NOW to the slot's END time.
     If less remains, the slot is disabled for today. */
  const SLOT_MIN_LEAD_HOURS = 2;

  const state = {
    mode: 'delivery',
    location: '',
    dateMode: 'tomorrow',
    scheduleDate: '',
    timeSlot: '',
    gift: false
  };

  const locationEl = root.querySelector('[data-rv-location]');
  const slotsEl = root.querySelector('[data-rv-slots]');
  const slotTitleEl = root.querySelector('[data-rv-time-title]');
  const scheduleWrap = root.querySelector('[data-rv-schedule]');
  const scheduleInput = root.querySelector('[data-rv-schedule-input]');
  const errorsEl = root.querySelector('[data-rv-errors]');
  const giftCheck = root.querySelector('[data-rv-gift-check]');
  const giftFields = root.querySelector('[data-rv-gift-fields]');
  const selfFields = root.querySelector('[data-rv-self-fields]');
  const deliveryPanel = root.querySelector('[data-rv-panel="delivery"]');
  const pickupPanel = root.querySelector('[data-rv-panel="pickup"]');

  /* Set schedule input min = tomorrow */
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const minDate = tomorrow.toISOString().slice(0, 10);
  scheduleInput.min = minDate;

  function el(tag, attrs, children) {
    const node = document.createElement(tag);
    if (attrs) {
      for (const k in attrs) {
        if (k === 'class') node.className = attrs[k];
        else if (k === 'text') node.textContent = attrs[k];
        else if (k.startsWith('data-') || k === 'role' || k.startsWith('aria-') || k === 'type' || k === 'disabled') {
          if (k === 'disabled' && !attrs[k]) continue;
          node.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
        } else {
          node[k] = attrs[k];
        }
      }
    }
    if (children) children.forEach((c) => c && node.appendChild(c));
    return node;
  }

  function setError(msg) {
    errorsEl.textContent = msg || '';
  }

  function isCutoffPassed(location) {
    if (!location || !(location in CUTOFFS)) return false;
    const now = new Date();
    return now.getHours() >= CUTOFFS[location];
  }

  function renderSlots() {
    slotsEl.replaceChildren();
    state.timeSlot = '';

    if (!state.location) {
      slotsEl.appendChild(el('div', { class: 'rv-time-slot rv-time-slot--info', text: 'Select an emirate to see available delivery times.' }));
      return;
    }

    if (BLOCKED_EMIRATES.includes(state.location)) {
      slotTitleEl.textContent = 'Delivery unavailable';
      const blocked = el('div', { class: 'rv-time-slot rv-time-slot--info rv-time-slot--blocked' });
      const strong = el('strong', { text: 'Sorry — we don\'t deliver to ' + state.location + ' yet.' });
      blocked.appendChild(strong);
      blocked.appendChild(document.createElement('br'));
      blocked.appendChild(document.createTextNode('Please reach out on WhatsApp and our atelier will help you find an alternative.'));
      slotsEl.appendChild(blocked);
      return;
    }

    if (NAMED_EMIRATES.includes(state.location)) {
      slotTitleEl.textContent = 'Delivery time';
      const cutoffPassed = isCutoffPassed(state.location);
      const isToday = state.dateMode === 'today';
      const now = new Date();
      const nowHoursDecimal = now.getHours() + (now.getMinutes() / 60);
      NAMED_SLOTS.forEach((slot) => {
        const btn = el('button', { type: 'button', class: 'rv-time-slot', text: slot, role: 'radio', 'aria-checked': 'false' });
        btn.dataset.rvSlot = slot;
        let disabled = false;
        if (isToday && cutoffPassed) disabled = true;
        /* Enforce minimum lead time: the slot's END must be at least
           SLOT_MIN_LEAD_HOURS from now. So a customer ordering at
           1 PM can still pick 2-6 PM (5h remaining) but not 10 AM-2 PM
           (1h remaining). */
        const endHour = SLOT_END_HOURS[slot];
        if (isToday && endHour !== undefined && (endHour - nowHoursDecimal) < SLOT_MIN_LEAD_HOURS) {
          disabled = true;
        }
        if (disabled) {
          btn.disabled = true;
          btn.classList.add('is-disabled');
        }
        slotsEl.appendChild(btn);
      });
    } else {
      slotTitleEl.textContent = 'Delivery time';
      const info = el('div', { class: 'rv-time-slot rv-time-slot--info' });
      const strong = el('strong', { text: state.location });
      info.appendChild(strong);
      const window = getEveningWindow(state.location);
      info.appendChild(document.createTextNode(' — delivered in the evening, between ' + window.start + ' and ' + window.end + '.'));
      slotsEl.appendChild(info);
      state.timeSlot = window.value;
    }
  }

  function updateTodayTabState() {
    const todayTab = root.querySelector('[data-rv-date="today"]');
    const cutoffPassed = isCutoffPassed(state.location);
    todayTab.disabled = !!cutoffPassed;
    if (cutoffPassed && state.dateMode === 'today') {
      setDateMode('tomorrow');
    }
  }

  function setDateMode(mode) {
    state.dateMode = mode;
    root.querySelectorAll('[data-rv-date]').forEach((b) => {
      const active = b.dataset.rvDate === mode;
      b.classList.toggle('rv-date-tab--active', active);
      b.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    scheduleWrap.hidden = mode !== 'schedule';
    if (mode !== 'schedule') state.scheduleDate = '';
    renderSlots();
    setError('');
  }

  function setMode(mode) {
    state.mode = mode;
    root.querySelectorAll('[data-rv-mode]').forEach((b) => {
      const active = b.dataset.rvMode === mode;
      b.classList.toggle('rv-mode__btn--active', active);
      b.className = (active ? 'button ' : 'button-secondary ') + 'rv-mode__btn' + (active ? ' rv-mode__btn--active' : '');
      b.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    deliveryPanel.hidden = mode !== 'delivery';
    pickupPanel.hidden = mode !== 'pickup';
    setError('');
  }

  /* Wire location */
  locationEl.addEventListener('change', () => {
    state.location = locationEl.value;
    updateTodayTabState();
    renderSlots();
    setError('');
    persist();
  });

  /* Wire date tabs */
  root.querySelectorAll('[data-rv-date]').forEach((tab) => {
    tab.addEventListener('click', () => {
      if (tab.disabled) return;
      setDateMode(tab.dataset.rvDate);
      persist();
    });
  });

  scheduleInput.addEventListener('change', () => {
    state.scheduleDate = scheduleInput.value;
    setError('');
    persist();
  });

  /* Wire slot click */
  slotsEl.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-rv-slot]');
    if (!btn || btn.disabled) return;
    state.timeSlot = btn.dataset.rvSlot;
    slotsEl.querySelectorAll('[data-rv-slot]').forEach((s) => {
      const active = s === btn;
      s.classList.toggle('rv-time-slot--active', active);
      s.setAttribute('aria-checked', active ? 'true' : 'false');
    });
    setError('');
    persist();
  });

  /* Wire mode toggle */
  root.querySelectorAll('[data-rv-mode]').forEach((b) => {
    b.addEventListener('click', () => {
      setMode(b.dataset.rvMode);
      persist();
    });
  });

  /* Wire gift toggle (card buttons replace checkbox) */
  const giftOptions = root.querySelectorAll('[data-rv-gift-mode]');
  function setGiftMode(mode) {
    state.gift = (mode === 'gift');
    giftCheck.checked = state.gift;
    giftFields.hidden = !state.gift;
    if (selfFields) selfFields.hidden = state.gift;
    giftOptions.forEach((b) => {
      const active = b.dataset.rvGiftMode === mode;
      b.classList.toggle('rv-gift__option--active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
  giftOptions.forEach((b) => {
    b.addEventListener('click', () => {
      setGiftMode(b.dataset.rvGiftMode);
      persist();
    });
  });
  /* Legacy checkbox fallback in case some code still flips it */
  giftCheck.addEventListener('change', () => {
    setGiftMode(giftCheck.checked ? 'gift' : 'self');
    persist();
  });

  /* Wire gift + address + self-contact fields persistence on change */
  root.querySelectorAll('[data-rv-attr], [data-rv-addr], [data-rv-self]').forEach((input) => {
    input.addEventListener('change', persist);
    input.addEventListener('blur', persist);
    input.addEventListener('input', persist);
  });

  /* Save current state to Shopify cart attributes via /cart/update.js.
     Cleared fields submit empty strings so Shopify drops them from the
     cart — this is essential before checkout, otherwise leftover keys
     from a previous toggle (Gift, Pickup, scheduled date) can collide
     with the current mode and Shopify's checkout extension returns a
     500 / "There was a problem with our checkout" page. */
  const STALE_GIFT_KEYS = [
    'Gift', 'Gift Recipient Name', 'Gift Recipient Contact', 'Gift Sender', 'Gift Sender Phone', 'Gift Message',
    /* Legacy keys from earlier theme versions — always wipe so they
       can't sneak into a fresh cart. */
    'Gift Recipient', 'Recipient name', 'Recipient contact', 'Personal message', 'Sender name'
  ];
  const STALE_SELF_KEYS = ['Contact Name', 'Contact Phone'];
  const STALE_DELIVERY_KEYS = [
    'Delivery Location', 'Delivery Date', 'Delivery Time', 'Service',
    'Delivery Building', 'Delivery Street', 'Delivery Apartment',
    'Delivery Area', 'Delivery Landmark'
  ];
  /* Required address fields when fulfilment = Delivery. */
  const REQUIRED_ADDR_KEYS = ['Delivery Building', 'Delivery Street', 'Delivery Area'];

  /* Areas we do NOT deliver to (Western Region / Al Dhafra and other
     out-of-coverage zones). Matching is case-insensitive on whole
     words inside the Delivery Area or Delivery Street text. Add
     more via the data-rv-blocked-areas attribute on root if needed. */
  const DEFAULT_BLOCKED_AREAS = [
    'liwa', 'ghayathi', 'madinat zayed', 'mirfa', 'ruwais',
    'sila', 'silaa', 'bida zayed', 'delma', 'dalma',
    'al dhafra', 'al gharbia', 'western region'
  ];
  function getBlockedAreas() {
    const fromAttr = (root.dataset.rvBlockedAreas || '').toLowerCase().split(',').map(s => s.trim()).filter(Boolean);
    return fromAttr.length ? fromAttr : DEFAULT_BLOCKED_AREAS;
  }
  function findBlockedMatch() {
    const areaInput = root.querySelector('[data-rv-addr="Delivery Area"]');
    const streetInput = root.querySelector('[data-rv-addr="Delivery Street"]');
    const haystack = ((areaInput && areaInput.value) + ' ' + (streetInput && streetInput.value)).toLowerCase();
    for (const blocked of getBlockedAreas()) {
      if (!blocked) continue;
      const re = new RegExp('\\b' + blocked.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'i');
      if (re.test(haystack)) return blocked;
    }
    return null;
  }

  function buildAttributes() {
    const attrs = {};
    if (state.mode === 'pickup') {
      attrs['Fulfillment'] = 'Store Pickup';
      attrs['Pickup Location'] = (root.dataset.rvPickupMap || '');
      STALE_DELIVERY_KEYS.forEach((k) => { attrs[k] = ''; });
    } else {
      attrs['Fulfillment'] = 'Delivery';
      attrs['Pickup Location'] = '';
      attrs['Delivery Location'] = state.location || '';
      let dateStr = '';
      const today = new Date();
      if (state.dateMode === 'today') {
        dateStr = today.toISOString().slice(0, 10);
      } else if (state.dateMode === 'tomorrow') {
        const t = new Date(today);
        t.setDate(t.getDate() + 1);
        dateStr = t.toISOString().slice(0, 10);
      } else if (state.dateMode === 'schedule') {
        dateStr = state.scheduleDate || '';
      }
      attrs['Delivery Date'] = dateStr;
      attrs['Delivery Time'] = state.timeSlot || '';
      /* Recipient address (replaces Shopify's checkout shipping form
         now that products are flagged as not requiring shipping). */
      root.querySelectorAll('[data-rv-addr]').forEach((input) => {
        attrs[input.dataset.rvAddr] = (input.value || '').trim();
      });
    }
    if (state.gift) {
      attrs['Gift'] = 'Yes';
      root.querySelectorAll('[data-rv-attr]').forEach((input) => {
        attrs[input.dataset.rvAttr] = input.value || '';
      });
      STALE_SELF_KEYS.forEach((k) => { attrs[k] = ''; });
    } else {
      STALE_GIFT_KEYS.forEach((k) => { attrs[k] = ''; });
      root.querySelectorAll('[data-rv-self]').forEach((input) => {
        attrs[input.dataset.rvSelf] = (input.value || '').trim();
      });
    }
    return attrs;
  }

  let persistTimer = null;
  function persist() {
    if (persistTimer) clearTimeout(persistTimer);
    persistTimer = setTimeout(() => {
      const attrs = buildAttributes();
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(() => { /* swallow — best-effort sync */ });
    }, 250);
  }

  /* Validate and intercept checkout. Find the cart form's checkout button
     and verify required fields before allowing submit. */
  function validate() {
    if (state.mode === 'pickup') return null;
    /* Hard blockers — out-of-coverage location, can't take the order. */
    if (BLOCKED_EMIRATES.includes(state.location)) {
      return 'Sorry — we do not yet deliver to ' + state.location + '. Please reach out on WhatsApp.';
    }
    const blockedMatch = findBlockedMatch();
    if (blockedMatch) {
      return 'Sorry — we do not yet deliver to ' + blockedMatch + '. Please reach out on WhatsApp to discuss alternatives.';
    }
    /* Only sender phone is required by JS — other * fields are visual
       reminders but won't block checkout (per team policy). */
    if (state.gift) {
      const sphone = root.querySelector('#rv-gift-sender-phone');
      if (!sphone || !sphone.value.trim()) return 'Please enter your phone number so we can reach you about the order.';
    }
    return null;
  }

  /* Hold checkout submission until cart attributes are confirmed flushed.
     The previous fire-and-forget keepalive fetch could race the redirect
     to /checkouts/cn/..., leaving Shopify with a half-stale attribute
     set ("Fulfillment: Delivery" but "Delivery Date: ''", or a Gift toggle
     flipped without the matching fields). Shopify's checkout extension
     500s on those combos. We now `await` the update before re-submitting. */
  /* Show the missing-field error AND scroll to + focus the offending input.
     Maps the validate() error string back to which input caused it so we can
     red-flag the right one. */
  function focusMissingField(errorMsg) {
    let target = null;
    if (/recipient.+name/i.test(errorMsg))    target = root.querySelector('#rv-gift-receiver-name');
    else if (/recipient.+contact/i.test(errorMsg)) target = root.querySelector('#rv-gift-receiver-contact');
    else if (state.gift && /phone number/i.test(errorMsg)) target = root.querySelector('#rv-gift-sender-phone');
    else if (!state.gift && /phone number/i.test(errorMsg)) target = root.querySelector('#rv-self-phone');
    else if (/your name/i.test(errorMsg))     target = root.querySelector('#rv-self-name');
    else if (/emirate/i.test(errorMsg))       target = root.querySelector('#rv-location');
    else if (/time slot/i.test(errorMsg))     target = root.querySelector('[data-rv-slots]');
    else if (/delivery date/i.test(errorMsg)) target = root.querySelector('[data-rv-schedule-input]');
    else if (/building/i.test(errorMsg))      target = root.querySelector('[data-rv-addr="Delivery Building"]');
    else if (/street/i.test(errorMsg))        target = root.querySelector('[data-rv-addr="Delivery Street"]');
    else if (/area/i.test(errorMsg))          target = root.querySelector('[data-rv-addr="Delivery Area"]');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => { try { target.focus(); } catch (_) {} }, 300);
    } else {
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function bindCheckoutInterception() {
    /* Backup #1 — capture-phase click on any element named "checkout".
       Fires BEFORE the form's submit listener and BEFORE Shopify's
       internal handlers, so it blocks even when accelerated /
       JS-bypass paths skip the form's native submit event. */
    document.addEventListener('click', (e) => {
      const btn = e.target.closest && e.target.closest('[name="checkout"], button[name="checkout"]');
      if (!btn) return;
      const error = validate();
      if (error) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        setError(error);
        focusMissingField(error);
      }
    }, true /* capture */);

    const allForms = document.querySelectorAll('form[action*="/cart"]');
    if (!allForms.length) return;
    allForms.forEach((cartForm) => {
      let allowSubmit = false;
      cartForm.addEventListener('submit', async (e) => {
        if (allowSubmit) return;
        const error = validate();
        if (error) {
          e.preventDefault();
          setError(error);
          focusMissingField(error);
          return;
        }
        /* Block the navigation, flush attributes, then resubmit. */
        e.preventDefault();
        const submitBtn = cartForm.querySelector('[name="checkout"], button[type="submit"][name="checkout"]');
        if (submitBtn) submitBtn.disabled = true;
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: buildAttributes() })
          });
        } catch (_) {}
        if (submitBtn) submitBtn.disabled = false;
        allowSubmit = true;
        cartForm.requestSubmit ? cartForm.requestSubmit(submitBtn || undefined) : cartForm.submit();
      });
    });
  }

  /* Hydrate from existing cart attributes if any. Helps when the user navigates
     back and forth between cart and other pages without losing what they entered. */
  function hydrate() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then((r) => r.ok ? r.json() : null)
      .then((cart) => {
        if (!cart || !cart.attributes) return;
        const a = cart.attributes;
        if (a['Fulfillment'] === 'Store Pickup') setMode('pickup');
        if (a['Delivery Location']) {
          state.location = a['Delivery Location'];
          locationEl.value = a['Delivery Location'];
          updateTodayTabState();
          renderSlots();
          updateExpressVisibility();
        }
        if (a['Delivery Time']) {
          state.timeSlot = a['Delivery Time'];
          const match = slotsEl.querySelector('[data-rv-slot="' + CSS.escape(a['Delivery Time']) + '"]');
          if (match && !match.disabled) {
            match.classList.add('rv-time-slot--active');
            match.setAttribute('aria-checked', 'true');
          }
        }
        /* Re-fill address inputs from saved cart attributes. */
        root.querySelectorAll('[data-rv-addr]').forEach((input) => {
          const saved = a[input.dataset.rvAddr];
          if (saved && !input.value) input.value = saved;
        });
        if (a['Gift'] === 'Yes') {
          setGiftMode('gift');
          const rn = root.querySelector('#rv-gift-receiver-name');
          const rc = root.querySelector('#rv-gift-receiver-contact');
          const rs = root.querySelector('#rv-gift-sender');
          const rsp = root.querySelector('#rv-gift-sender-phone');
          const rm = root.querySelector('#rv-gift-message');
          if (a['Gift Recipient Name'] && rn) rn.value = a['Gift Recipient Name'];
          if (a['Gift Recipient Contact'] && rc) rc.value = a['Gift Recipient Contact'];
          if (a['Gift Sender'] && rs) rs.value = a['Gift Sender'];
          if (a['Gift Sender Phone'] && rsp) rsp.value = a['Gift Sender Phone'];
          if (a['Gift Message'] && rm) rm.value = a['Gift Message'];
          /* Legacy migration: if older cart had single "Gift Recipient" attr, dump into name field */
          if (a['Gift Recipient'] && rn && !rn.value) rn.value = a['Gift Recipient'];
        } else {
          const sn = root.querySelector('#rv-self-name');
          const sp = root.querySelector('#rv-self-phone');
          if (a['Contact Name'] && sn && !sn.value) sn.value = a['Contact Name'];
          if (a['Contact Phone'] && sp && !sp.value) sp.value = a['Contact Phone'];
        }
      })
      .catch(() => {});
  }

  /* === Cart upsells ===
     Upsell buttons are now server-rendered in delivery-details.liquid
     with data attributes (variant id + name). We just wire click
     handlers and toggle add/remove. */
  const EXPRESS_VARIANT_ID = 54083183018268;

  const upsellsGrid = root.querySelector('[data-rv-upsells-grid]');
  const expressWrap = root.querySelector('[data-rv-express-wrap]');
  const expressInput = root.querySelector('[data-rv-express]');
  const cartLineKeys = {}; /* variantId → cart line key, for removal */

  function renderUpsells() {
    /* Server-side rendered already. Just wire clicks. */
    if (!upsellsGrid) return;
    upsellsGrid.querySelectorAll('.rv-upsell').forEach((btn) => {
      const variantId = Number(btn.dataset.rvUpsellVariant);
      const name = btn.dataset.rvUpsellName || '';
      if (!variantId) return;
      btn.addEventListener('click', () => toggleUpsell({ variantId, name }, btn));
    });
  }

  async function toggleUpsell(u, btn) {
    btn.disabled = true;
    const isSelected = btn.classList.contains('rv-upsell--selected');
    try {
      if (isSelected) {
        await removeFromCart(u.variantId);
        markUpsell(btn, false);
      } else {
        await addToCart(u.variantId, 1, { 'Add-on': u.name });
        markUpsell(btn, true);
      }
    } catch (_) { /* keep state as-is on failure */ }
    btn.disabled = false;
  }

  function markUpsell(btn, selected) {
    btn.classList.toggle('rv-upsell--selected', selected);
    btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
    const action = btn.querySelector('[data-rv-upsell-action]');
    if (action) action.textContent = selected ? '✓ Added' : '+ Add';
  }

  async function addToCart(variantId, quantity, properties) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1, properties: properties || {} }] })
    });
    if (!r.ok) throw new Error('add failed');
    const data = await r.json();
    const item = (data.items && data.items[0]) || null;
    if (item && item.key) cartLineKeys[variantId] = item.key;
    publishAddedToCart(item, quantity || 1);
    return data;
  }

  /* Tell Shopify's customer-events bus that a product was added. This is
     what Meta Pixel / TikTok / Google Ads / Klaviyo all listen on. Without
     it, AJAX cart adds are invisible to every pixel and conversion
     attribution breaks. Shape mirrors Shopify's canonical event payload. */
  function publishAddedToCart(item, quantity) {
    if (!item || !window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    try {
      window.Shopify.analytics.publish('product_added_to_cart', {
        cart_line: {
          cost: { totalAmount: { amount: (item.final_price || item.price || 0) / 100, currencyCode: (window.Shopify.currency && window.Shopify.currency.active) || 'AED' } },
          merchandise: {
            id: String(item.variant_id || item.id),
            image: item.image ? { src: item.image } : null,
            price: { amount: (item.price || 0) / 100, currencyCode: (window.Shopify.currency && window.Shopify.currency.active) || 'AED' },
            product: {
              id: String(item.product_id || ''),
              title: item.product_title || item.title || '',
              vendor: item.vendor || '',
              type: item.product_type || '',
              untranslatedTitle: item.product_title || item.title || '',
              url: item.url || ''
            },
            sku: item.sku || '',
            title: item.variant_title || '',
            untranslatedTitle: item.variant_title || ''
          },
          quantity: quantity
        }
      });
    } catch (_) {}
  }

  async function removeFromCart(variantId) {
    let key = cartLineKeys[variantId];
    if (!key) {
      const c = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then((x) => x.json());
      const match = (c.items || []).find((i) => (i.variant_id === variantId) || (i.id === variantId));
      if (match) {
        key = match.key;
        cartLineKeys[variantId] = key;
      }
    }
    if (!key) return;
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    if (!r.ok) throw new Error('remove failed');
    delete cartLineKeys[variantId];
  }

  /* === Express delivery visibility — Abu Dhabi only ===
     Dubai + Sharjah city still get same-day windows (until 3 PM cutoff),
     but the 2-hour express upgrade is exclusive to Abu Dhabi.

     Also: if the customer switches to Pickup or to a non-Abu-Dhabi
     emirate, the express line item must be removed from cart so it
     can't drift into checkout (Shopify's checkout extension validates
     line items against the chosen fulfilment mode and 500s on
     mismatched delivery services). */
  const EXPRESS_EMIRATES = ['Abu Dhabi'];
  function updateExpressVisibility() {
    const eligible = state.mode === 'delivery' && EXPRESS_EMIRATES.indexOf(state.location) !== -1;
    if (expressWrap) expressWrap.hidden = !eligible;
    if (!eligible && expressInput && expressInput.checked) {
      expressInput.checked = false;
      expressOptions.forEach((b) => {
        const isStandard = b.dataset.rvExpressMode === 'standard';
        b.classList.toggle('rv-gift__option--active', isStandard);
        b.setAttribute('aria-pressed', isStandard ? 'true' : 'false');
      });
      removeFromCart(EXPRESS_VARIANT_ID).catch(() => {});
    }
  }

  if (expressInput) {
    expressInput.addEventListener('change', async () => {
      expressInput.disabled = true;
      try {
        if (expressInput.checked) {
          await addToCart(EXPRESS_VARIANT_ID, 1, { 'Service': 'Express 2-hour window' });
        } else {
          await removeFromCart(EXPRESS_VARIANT_ID);
        }
      } catch (_) {
        expressInput.checked = !expressInput.checked;
      }
      expressInput.disabled = false;
    });
  }

  /* Card-style toggle for Express delivery (mirrors gift toggle) */
  const expressOptions = root.querySelectorAll('[data-rv-express-mode]');
  function setExpressMode(mode) {
    const isExpress = (mode === 'express');
    expressOptions.forEach((b) => {
      const active = b.dataset.rvExpressMode === mode;
      b.classList.toggle('rv-gift__option--active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    if (expressInput && expressInput.checked !== isExpress) {
      expressInput.checked = isExpress;
      expressInput.dispatchEvent(new Event('change'));
    }
  }
  expressOptions.forEach((b) => {
    b.addEventListener('click', () => setExpressMode(b.dataset.rvExpressMode));
  });

  /* Tap into existing handlers to refresh express visibility on mode/location changes */
  locationEl.addEventListener('change', updateExpressVisibility);
  root.querySelectorAll('[data-rv-mode]').forEach((b) => {
    b.addEventListener('click', () => setTimeout(updateExpressVisibility, 0));
  });

  /* Hydrate upsells + express state from current cart */
  function hydrateUpsells() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then((r) => r.ok ? r.json() : null)
      .then((cart) => {
        if (!cart) return;
        const inCart = new Set();
        (cart.items || []).forEach((it) => {
          const vid = it.variant_id || it.id;
          inCart.add(vid);
          cartLineKeys[vid] = it.key;
        });
        if (upsellsGrid) {
          upsellsGrid.querySelectorAll('.rv-upsell').forEach((btn) => {
            const vid = Number(btn.dataset.rvUpsellVariant);
            if (vid && inCart.has(vid)) markUpsell(btn, true);
          });
        }
        if (expressInput && inCart.has(EXPRESS_VARIANT_ID)) {
          expressInput.checked = true;
          /* Sync visual toggle */
          if (typeof setExpressMode === 'function') setExpressMode('express');
        }
      })
      .catch(() => {});
  }

  renderUpsells();
  setMode('delivery');
  setDateMode('tomorrow');
  renderSlots();
  hydrate();
  hydrateUpsells();
  updateExpressVisibility();
  bindCheckoutInterception();
})();
